export const DEFAULT_ROWS_PER_PAGE = [10, 20, 30, 40, 50];
export const INIT_ROWS_PER_PAGE = 10;
export const DESKTOP_TOTAL_NUMBERS = 8;
export const MOBILE_TOTAL_NUMBERS = 5;
export const MOBILE_PAGE_NEIGHBOURS = 1;
export const DESKTOP_PAGE_NEIGHBOURS = 2;
export const LEFT_PAGE = -1;
export const RIGHT_PAGE = -2;
